import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.configContainer`;
export const INIT = `${SCOPE}/INIT`;
export const ADD_OR_RULE = `${SCOPE}/ADD_OR_RULE`;
export const UPDATE_OR_RULE = `${SCOPE}/UPDATE_OR_RULE`;
export const CREATE_CONFIG = `${SCOPE}/CREATE_CONFIG`;
export const UPDATE_CONFIG = `${SCOPE}/UPDATE_CONFIG`;
export const DELETE_OR_RULE = `${SCOPE}/DELETE_OR_RULE`;
export const UPDATE_CONFIG_CONDITIONS = `${SCOPE}/UPDATE_FILTER_CONDITIONS`;
export const CHANGE_CONFIG_CONTAINER_VISIBILITY = `${SCOPE}/CHANGE_CONFIG_CONTAINER_VISIBILITY`;
export const CLEAR_CONFIG_FORM = `${SCOPE}/CLEAR_CONFIG_FORM`;
